<div class="modal-header">
    <span class="modal-header-title">{{ 'EMPLOEE.EDIT_EMLOEE_DETAILS' | translate }}</span>
    <div class="tool">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true">&times;</span>
        </button>
   </div>
</div>
<div class="modal-body">

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12">
                <div class="form-group">
                    <label for="department">{{ 'EMPLOEE.DEPARTMENT' | translate }}</label>
                    <ng-select  
                        id="department"
                        class="custom" 
                        clearAllText="{{ 'CLEAN' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="department_id"
                        [loading]="loading"
                        [items]="departments"
                        >
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.department">
                            <div class="text-error" *ngIf="validation('department_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>   

            <div class="col-6">

                <div class="form-group">
                    <label for="position">{{ 'EMPLOEE.POSITION' | translate }}</label>
                    <ng-select  
                        id="position"
                        class="custom" 
                        clearAllText="{{ 'CLEAN' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="position_id"
                        [loading]="loading"
                        [items]="positions"
                        >
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.position">
                            <div class="text-error" *ngIf="validation('department_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-6">

                <div class="form-group">
                    <label for="urole_id">{{ 'ROLE' | translate }}</label>
                    <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                    [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}">
                    </svg-icon>
                    <ng-select  
                        id="position"
                        class="custom" 
                        clearAllText="{{ 'CLEAN' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="urole_id"
                        [loading]="loading"
                        [items]="uroles"
                        >
                    </ng-select>
                    <!-- <select class="form-control" id="urole_id" formControlName="urole_id">
                        <option *ngFor="let urole of uroles" [value]="urole.id">{{ urole.name }}</option>
                    </select> -->
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.urole_id">
                            <div class="text-error" *ngIf="validation('urole_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>
    
            </div>

        </div>

    </form>

</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
</div>